import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const PorkteinRoot = styled('div', {
  background: '$secondary-100',
  width: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '$7',
  overflow: 'hidden',
  height: '850px',

  '& .d-only': {
    display: 'none',
  },
  '& .m-only': {
    display: 'block',
  },
  '@bp3': {
    height: 'auto',
    paddingBottom: '$6',
    '& .d-only': {
      display: 'block',
    },
    '& .m-only': {
      display: 'none',
    },
  },
})

export const BagImage = styled('div', {
  position: 'absolute',
  width: '436px',
  margin: 'auto',
  zIndex: 1,
  top: '220px',

  '@bp3': {
    width: '850px',
    position: 'relative',
    top: 'unset',
  },
})

export const Feat1 = styled(Text, {
  position: 'absolute',
  left: 0,
  right: 0,
  margin: 'auto',
  zIndex: 1,
  top: '210px',

  '@bp3': {
    left: 0,
    right: 0,
    top: '400px',
    transform: 'translateX(-540px)',
  },
})

export const Feat2 = styled(Text, {
  position: 'absolute',
  left: 0,
  right: 0,
  top: '700px',
  margin: 'auto',

  '@bp3': {
    left: 0,
    right: 0,
    top: '530px',
    transform: 'translateX(-400px)',
  },
})

export const Feat3 = styled(Text, {
  position: 'absolute',
  left: 0,
  right: 0,
  top: '660px',
  margin: 'auto',

  '@bp3': {
    left: 0,
    right: 0,
    top: '600px',
    transform: 'translateX(420px)',
  },
})

export const Shoelace = styled('div', {
  position: 'absolute',
  left: 0,
  right: 0,
  top: '200px',
  transform: 'translateY(-110px)',
  margin: 'auto',
  zIndex: 1,
  textAlign: 'center',
  rotate: '90deg',
  width: '190px',

  '@bp3': {
    rotate: '0deg',
    right: 0,
    top: '200px',
    width: '210px',
    left: 0,
    transform: 'translateX(-350px)',
  },
})

export const Cup = styled('div', {
  position: 'absolute',

  left: '250px',
  right: 0,
  margin: 'auto',
  zIndex: 1,
  textAlign: 'center',
  top: '570px',
  rotate: '-140deg',
  width: '90px',

  '@mobile': {
    left: '300px',
  },

  '@bp3': {
    rotate: '0deg',
    width: '99px',
    right: 0,
    top: '570px',
    left: 0,
    transform: 'translateX(-290px)',
  },
})

export const Snake = styled('div', {
  position: 'absolute',

  left: 0,
  right: 0,
  margin: 'auto',
  zIndex: 1,
  textAlign: 'center',

  '@bp3': {
    right: 0,
    top: '655px',
    left: 0,
    transform: 'translateX(290px)',
  },
})

export const BlobWrapper = styled('div', {
  position: 'absolute',
  zIndex: 0,
  top: '250px',
  left: 'unset',
  right: 'unset',
  margin: 'auto',
  textAlign: 'center',
  transform: 'translateX(-20px)',

  '& svg': {
    width: '472px',
  },

  '@bp3': {
    width: '850px',
    top: '400px',
    right: '60px',
    left: 0,
    '& svg': {
      width: '850px',
    },
  },
})

export const BadgeWrapper = styled('div', {
  position: 'absolute',
  zIndex: 2,
  bottom: 'unset',
  top: '450px',
  left: 0,
  right: '220px',
  margin: 'auto',
  textAlign: 'center',
  width: '98px',
  height: '98px',
  display: 'none',

  '@mobile': {
    display: 'block',
  },

  '@bp3': {
    height: '163px',
    width: '163px',
    bottom: '170px',
    top: 'unset',
    right: '450px',
  },
})

export const ButtonWrapper = styled('div', {
  position: 'absolute',
  top: '755px',
  margin: 'auto',
  display: 'block',
  width: '100%',
  textAlign: 'center',

  '@bp3': {
    display: 'none',
  },
})

export const BorderWrapper = styled('div', {
  background: '$secondary-150',
  position: 'relative',
  top: '1px',

})

export const UnboxingWrapper = styled('div', {
  position: 'absolute',
  zIndex: 1,
  left: 0,
  right: 0,
  top: '-80px',
  margin: 'auto',
  width: '233px',
  display: 'none',

  '@bp3': { display: 'block' }
})